import { color } from '@figma/fpl-tokens/tokens.stylex';
import { Tag, type TagProps } from './Tag';

type IndicatorTagProps = Pick<TagProps, 'variant' | 'sx' | 'disableTextTransform'> & {
  text: string;
};

export const IndicatorTag = ({ text, variant, sx, disableTextTransform }: IndicatorTagProps) => (
  <Tag
    text={text}
    textColor={color.text}
    bgColor={color.bgTertiary}
    variant={variant}
    disableTextTransform={disableTextTransform}
    sx={sx}
  />
);
